"use client";
import { useEffect, useRef } from "react";
import { useAuth } from "@/app/lib/AuthProvider";
// import { useAppDispatch } from '@store/hooks';
// import { addQuestion } from '@store/features/questionSlice';
// import { ComponentTypeEnum } from '@app/types/typeConfig/chatQuestion';
// import dynamic from 'next/dynamic';
// import { generateUniqueId } from '@/utils';
// import { isOversea } from '@/const/systemConfig';
// import { openUrl } from "@/app/utils";
import { webSocketService } from "../services/WebSocketService";
import { MessageSender, MessageType } from "../store/types";
import { getQuestionType } from "../api/config";
import { useMessageStore } from "@/app/store";
import { SocketConnectionStatus } from "@/app/store/types";
import { message } from "antd";
import Locale from "@/app/locales";
import { useChatInit } from "../hooks/useChatInit";
import { HeaderType, RobotMessageType } from "../store/types";

export default function ClickListener() {
  // const dispatch = useAppDispatch();
  const { isAuthenticated, login } = useAuth();
  const { isConnected, setRobotMessage } = useMessageStore();
  const { checkCanService, checkCanServiceInfo } = useChatInit();
  // 使用 ref 保存最新状态，避免闭包问题
  const isAuthenticatedRef = useRef(isAuthenticated);
  const isConnectedRef = useRef(isConnected);
  const checkCanServiceInfoRef = useRef(checkCanServiceInfo);

  useEffect(() => {
    checkCanServiceInfoRef.current = checkCanServiceInfo;
  }, [checkCanServiceInfo]);
  useEffect(() => {
    isAuthenticatedRef.current = isAuthenticated;
  }, [isAuthenticated]);
  useEffect(() => {
    isConnectedRef.current = isConnected;
  }, [isConnected]);

  useEffect(() => {
    // 这里只能拦截点击，不能拦截浏览器地址栏输入im链接的情况
    // 不在im页面去拦截是因为im页面都是_blank打开的链接，在handy app里面属于两个webview
    const handleClick = async (e: MouseEvent) => {
      // 使用 closest 向上查找最近的 <a> 标签
      // 这样即使用户点击的是 <a> 标签内部的子元素（如 <span>、<strong> 等），也能正确拦截
      const target = e.target as HTMLElement;
      const anchor = target.closest("a") as HTMLAnchorElement | null;

      // 如果没有找到 <a> 标签，直接返回
      if (!anchor) {
        return;
      }

      const href = anchor.href;

      // 调试日志：帮助排查 Flutter WebView 中的问题
      console.log("[AClickListener] 检测到链接点击:", {
        href,
        tagName: anchor.tagName,
        isTrusted: e.isTrusted,
        target: target.tagName,
      });
      // 强制匹配跳转链接里面有没有包含cn/im或者en/im
      // 这里需要注意的，直接在浏览器地址栏输入/im链接的情况是不会触发这个事件的
      if (
        href &&
        !href.startsWith("javascript:") &&
        (href.includes("/cn/im") ||
          href.includes("/en/im") ||
          href.includes("/im") ||
          href.includes("/im/") ||
          href.includes("/liveChat/"))
      ) {
        e.preventDefault();
        e.stopPropagation();
        // 判断是否登录，登录的话直接出现问题类型选择气泡，没有登录去登陆，登录回来后出现问题类型选择气泡
        // 使用 ref.current 获取最新的认证状态
        if (!isAuthenticatedRef.current) {
          console.log("没有登录，去登录");
          login("im");
        } else {
          // 如果已经在会话中，则不进行问题类型选择
          if (
            isConnectedRef.current === SocketConnectionStatus.DISCONNECTED ||
            isConnectedRef.current === SocketConnectionStatus.CLOSE
          ) {
            // 前置检查：实时请求接口判断客服是否在服务时间
            const canProceed = await checkCanService();
            if (!canProceed) {
              setRobotMessage({
                type: MessageType.Text,
                headerType: HeaderType.MESSAGE,
                senderType: MessageSender.ROBOT,
                messageType: RobotMessageType.ROBOT_NORMAL_REPLY,
                showFeedFooter: false,
                content: checkCanServiceInfoRef.current?.content || "",
                timestamp: Date.now(),
                senderName: "智能助手",
                robotData: {},
              });
              return;
            }
            // 已登录直接出现问题类型选择气泡
            getQuestionType().then((res) => {
              // 需要选择
              webSocketService.sendMessage(
                JSON.stringify({ questionList: res }),
                {
                  msgType: MessageType.QuestionList,
                  noNeedSendToWebsocket: true,
                  senderType: MessageSender.SYSTEM,
                  msgClassName: "emptyBackground",
                },
              );
            });
          } else {
            // 如果已经在会话中，则不进行问题类型选择,提示
            message.info(Locale.chat.hasIMSession);
            return;
          }
        }
      }
    };
    // 使用捕获阶段（第三个参数为 true）来确保在事件到达目标元素之前就能拦截
    // 这对于 Flutter WebView 等环境尤为重要，因为 WebView 可能在冒泡阶段之前就处理了链接跳转
    document.addEventListener("click", handleClick, true);
    return () => document.removeEventListener("click", handleClick, true);
  }, []);

  return null;
}
